export interface IConfigRelatorio {
  /** Tabela do layout em `laytel` (GET /layout?tabela=) com os filtros do relatório */
  tabela: string;
  /** Parâmetro `rel` do POST /relatorio */
  rel: string;
  /** Título da tela de filtros; sem ele, "Relatório <entidade>" */
  titulo?: string;
}

/** Relatórios disponíveis, indexados pela `:entidade` da rota em minúsculas */
export const RELATORIOS: Record<string, IConfigRelatorio> = {
  'fluxo de caixa': { tabela: 'RelFluCai', rel: 'FluCai' },
  'cheque das vendas': { tabela: 'RelCheVen', rel: 'CheVen' },
  // não pode ser 'vendas': essa entidade é o cadastro de pedidos (pedsai)
  'relatorio de vendas': { tabela: 'RelPedSai', rel: 'PedSai', titulo: 'Relatório de Vendas' }
};

export function getConfigRelatorio(entidade?: string): IConfigRelatorio | undefined {
  if (!entidade) return undefined;

  return RELATORIOS[entidade.toLowerCase()];
}
